export const getCarryingValueClarificationKey = (
  hasPreferenceShares: boolean,
  hasShareholderLoanNotes: boolean
) => {
  if (hasPreferenceShares && hasShareholderLoanNotes) {
    return '_CarryingValueClarificationBoth' as const;
  }
  if (hasPreferenceShares) {
    return '_CarryingValueClarificationPreferenceShares' as const;
  }
  if (hasShareholderLoanNotes) {
    return '_CarryingValueClarificationShareholderLoanNotes' as const;
  }
  return null;
};
